/* eslint-disable no-else-return, no-console */
import isNumber from "lodash-es/isNumber"
import { DateTime } from "luxon"

const START_TIME_BUFFER_IN_MINS: number = 15

function getIsSessionPast(params: { startDate: string; durationInMins: number }): boolean {
    const now: DateTime = DateTime.now()
    const start: DateTime = DateTime.fromISO(params.startDate)

    if (!start.isValid) {
        console.warn(`getIsSessionPast: Invalid startDate: ${params.startDate}`)
        return false
    }

    if (!isNumber(params.durationInMins) || params.durationInMins <= 0) {
        console.warn(`getIsSessionPast: Invalid durationInMinutes: ${params.durationInMins}`)
        return false
    }

    const end: DateTime = start.plus({ minutes: params.durationInMins })

    return now >= end
}

function getIsSessionLive(params: { startDate: string; durationInMins: number }): boolean {
    const now: DateTime = DateTime.now()
    const start: DateTime = DateTime.fromISO(params.startDate)

    if (!start.isValid) {
        console.warn(`getIsSessionLive: Invalid startDate: ${params.startDate}`)
        return false
    }

    if (!isNumber(params.durationInMins) || params.durationInMins <= 0) {
        console.warn(`getIsSessionLive: Invalid durationInMinutes: ${params.durationInMins}`)
        return false
    }

    const end: DateTime = start.plus({ minutes: params.durationInMins })

    if (getIsSessionPast(params)) return false

    const doesStartSoon: boolean = start.diff(now, "minutes").minutes <= START_TIME_BUFFER_IN_MINS
    const hasStarted: boolean = now >= start
    const hasEnded: boolean = now >= end

    return (doesStartSoon && !hasEnded) || (hasStarted && !hasEnded)
}

function getIsSessionUpcoming(params: { startDate: string; durationInMins: number }): boolean {
    const now: DateTime = DateTime.now()
    const start: DateTime = DateTime.fromISO(params.startDate)

    if (!start.isValid) {
        console.warn(`getIsSessionUpcoming: Invalid startDate: ${params.startDate}`)
        return false
    }

    if (!isNumber(params.durationInMins) || params.durationInMins <= 0) {
        console.warn(`getIsSessionUpcoming: Invalid durationInMinutes: ${params.durationInMins}`)
        return false
    }

    return start.diff(now, "minutes").minutes > START_TIME_BUFFER_IN_MINS
}

export default { getIsSessionPast, getIsSessionLive, getIsSessionUpcoming }
